var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"py-5"},[_c('request-materials',{ref:"request-materials",staticClass:"mt-4",attrs:{"show-type-status-filters":"","customSapStatus":true},on:{"requestMaterialsCreated":_vm.getRequestMaterials}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }